import React from 'react';
import { toast as notify } from 'react-toastify';
import LocalizedMessage from '../components/common/LocalizedMessage';
import { isAuthRecoveryActive, isAuthenticationRecovery } from '../services/sessionCoordinator';

// Keep the message mounted as a subscriber while a notification is visible.
const content = (value, isError = false) => <LocalizedMessage value={value} isError={isError} />;
const toast = (value, options) => notify(content(value), options);
['success', 'error', 'info', 'warn', 'warning'].forEach(level => {
  toast[level] = (value, options) => {
    if (level === 'error' && (isAuthenticationRecovery(value) || isAuthRecoveryActive())) return undefined;
    return notify[level](content(value, level === 'error'), options);
  };
});
export default toast;
